/*
  mem-generator contains logic to generate new game boards
*/
(function () {
  // An array of valid game tiles
  var tiles = 'abcdefghijklmnop'.split('');

  function gameBoard(numTiles) {
    var arr = tiles.slice(0, numTiles);
    return _.shuffle(arr.concat(arr));
  }

  mem.generator = {
    easy: function () {
      return gameBoard(9);
    },

    hard: function () {
      return gameBoard(16);
    }
  }
})();
